<template>
    <ModalComponent
        :name="'editar-' + documento.id"
        title="Editar documento"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <FormInput label="Nombre" name="Nombre" rules="required" v-model="nombre" />
            </div>
            <div class="col-12 text-right">
                <Button class="mr-1" type="button" name="button" @click="confirm">Editar</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['documento'],
        data() {
            return {
                nombre: this.documento.nombre
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            confirm() {
                this.documento.nombre = this.nombre;
                this.$emit('confirm', this.documento);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
